import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import settings from "@/scripts/common/settings"
import utilities from "@/scripts/common/utilities"
import { Loader } from '@/scripts/infinite-loader/Infinite-loader'
import { addScrollController } from "@/scripts/common/api/scrolltrigger.services"
import Pin from '@/scripts/pin/Pin'
import Ripple from '@/scripts/ripple'
import { ModalController } from '@/scripts/modal/Modal'
import { UIFilter } from '@/scripts/ui-filter/UIfilter'
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

export const Gallery = (() => {
    const CLASS_PRE = 'gallery'
    class GalleryListing {
        constructor(container) {
            this.$gallery = container
            this.$galleryFilter = this.$gallery.querySelector(`.${CLASS_PRE}__filter`)
            this.$galleryList = this.$gallery.querySelector(`.${CLASS_PRE}__list`)
            this.$filterTrigger = this.$gallery.querySelectorAll(`.${CLASS_PRE}__filter-trigger`)
            this.uiFilter = this.$gallery.classList.contains(`${CLASS_PRE}--ui`)
            this.isMobile = window.innerWidth < settings.breakpoints.mobile
            this.pin = null
            this.pinOptions = {
                start: 'top-=50 top',
                pinSpacing: false
            }
            this.infiniteLoaderOption = {
                skeletonLoaderStyle: 'figure',
                skeletonLoaderClass: 'gallery__item',
                skeletonLoaderNo: 4
            }
            
            this.scrollToActiveTimer = null
            this.init()
        }

        init() {
            if(!this.uiFilter) new Loader.InfiniteLoader(this.$galleryList, this.infiniteLoaderOption) // Infinite loader
            if(this.uiFilter) new UIFilter.Filter(this.$gallery).init() // UI filters
            this.pin = new Pin(this.$galleryFilter, this.$gallery, this.pinOptions) // Pining featured article
            this.updateUI()
            this.addListeners()
        }

        updateUI() {
            this.$filterTrigger.forEach(($t) => {
                $t.classList.remove(`${CLASS_PRE}__filter-trigger--active`)
            })

            if(!this.uiFilter) this.$galleryFilter.querySelector(`.${CLASS_PRE}__filter-trigger[data-selected]`).classList.add(`${CLASS_PRE}__filter-trigger--active`)
            
                
        }

        // Callbacks
        selectActive(e, item) {
            e.preventDefault()
            this.$filterTrigger.forEach($t => $t.removeAttribute('data-selected'))
            item.setAttribute('data-selected', '')

            this.updateUI()
        }

        // Refresh Pin
        refresh() {
            if (this.pin) this.pin.refresh()
            //if(!this.uiFilter) this.scrollToActive()
            
        }

        // Gallery item add
        onGalleryItemAdd(e) {
            const $galleryItemModal = e.detail.getAddedItem().querySelector(`[data-modal]`)
            const $galleryItemRipple = e.detail.getAddedItem().querySelector(`[data-ripple]`)
            if($galleryItemModal) new ModalController.Modal($galleryItemModal)
            if($galleryItemRipple) new Ripple($galleryItemRipple)
        }

        // Utilities
        scrollToActive() {
            if(this.scrollToActiveTimer) clearTimeout(this.scrollToActiveTimer)
            const $activeParentItem = this.$galleryFilter.querySelector(`.${CLASS_PRE}__filter-trigger[data-selected]`).parentNode

            this.scrollToActiveTimer = setTimeout(()=>{
                this.$galleryFilter.scrollTo($activeParentItem.getBoundingClientRect().left, 0)

                // gsap.to(this.$galleryFilter, {
                //     duration: 0.4,
                //     scrollTo: {
                //         x: $activeParentItem.getBoundingClientRect().left
                //     },
                //     ease: 'power2.inOut'
                // })

            },0)
            
        }

        // UI filter 
        onUiFilterStart() {
            gsap.to(window, {
                duration: 0.4,
                scrollTo: {
                    y: this.$gallery,
                    offsetY: 100
                },
                ease: 'power2.inOut'
            })

           // this.refresh()
        }

        // Adding listeners
        addListeners() {
            if(!this.uiFilter) this.$filterTrigger.forEach(($t) => $t.addEventListener('click', (e) => this.selectActive(e, $t)))
            this.$galleryList.addEventListener('onUpdate', () => this.refresh())
            this.$galleryList.addEventListener('onAdd', (e) => this.onGalleryItemAdd(e))
            this.$gallery.addEventListener('UIFilterStart', (e) => this.onUiFilterStart())
            this.$gallery.addEventListener('UIFilterUpdated', (e) => this.refresh())
        }
    }

    return {
        GalleryListing
    }
})()